import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/auth/AuthContext';
import type { ReactNode } from 'react';
import '@/pages/Login.css'; // branded .brew-splash while the session resolves

/** Gate a route on authentication. Redirects to /login while preserving
 *  the intended destination so we can bounce the user back after login. */
export function RequireAuth({ children }: { children: ReactNode }) {
  const auth = useAuth();
  const location = useLocation();

  if (auth.loading) {
    // Branded splash instead of a bare "Loading…" line — a slow auth/session
    // check should read as the app brewing, never as a blank/broken page (#5).
    return (
      <div className="brew-splash" role="status" aria-live="polite">
        <div className="brew-splash__inner">
          <img className="brew-splash__logo" src="/brew-logo.png" alt="Breww.ai" width={68} height={68} />
          <div className="brew-splash__spinner" aria-hidden="true" />
          <span className="brew-splash__text">Brewing your workspace…</span>
        </div>
      </div>
    );
  }
  if (!auth.user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }
  return <>{children}</>;
}
